import React from 'react'
import Link from 'gatsby-link'
const demographics = require('../../data/demographics.json')

//  Styles
import styles from './StateRankingTable.module.scss'

const StateRankingTable = ( { state, title } ) => {
  const data = require('../../data/ranking/' + state + '.json')
  const diffs = {
    OVERALL: data['OVERALL']['Baseline'] - data['OVERALL']['Current'],
    ACCESS: data['ACCESS']['Baseline'] - data['ACCESS']['Current'],
    QUALITY: data['QUALITY']['Baseline'] - data['QUALITY']['Current'],
    USE: data['USE']['Baseline'] - data['USE']['Current'],
    LIVES: data['LIVES']['Baseline'] - data['LIVES']['Current'],
    DISPARITY: data['DISPARITY']['Baseline'] - data['DISPARITY']['Current'],
    medicaid: data['medicaid']['Current'] === data['medicaid']['Baseline'] ?
      0 : (data['medicaid']['Current'] === 'Yes' ? 1 : 0),
  }
  const styleFromDiff = diff => {
    if (diff > 0) {
      return [styles.stat_change, styles.increase].join(" ")
    }
    if (diff < 0) {
      return [styles.stat_change, styles.decrease].join(" ")
    }
    return styles.stat_change
  }
  const rankingStyles = Object.keys(diffs).reduce((accumulator, value) => (
    {...accumulator, [value]: styleFromDiff(diffs[value])}
  ), {})
  const formattedDiffs = Object.keys(diffs).reduce((accumulator, value) => {
    let outputValue
    if (diffs[value] > 0) {
      outputValue = (value === 'medicaid') ? '' : '+' + diffs[value]
    }
    else if (diffs[value] < 0) {
      outputValue = (value === 'medicaid') ? '' : diffs[value]
    }
    else {
      outputValue = (value === 'medicaid') ? '' : 0
    }
    return {...accumulator, [value]: outputValue}
  }, {})
  return (
    <div>
      <h2 className="section__title__secondary">Ranking Highlights</h2>
      <div className={ styles.ranking__table__wrapper }>
        <table className={ styles.ranking__table }>
          <thead>
            <tr>
              <th></th>
              <th className={ styles.stat_value }>2018 Rank</th>
              <th className={ styles.stat_change }>Change from Baseline</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Overall Ranking</th>
              <td className={ styles.stat_value }>{ data['OVERALL']['Current'] }</td>
              <td className={ rankingStyles['OVERALL'] }>{ formattedDiffs['OVERALL'] }</td>
            </tr>
            <tr>
              <th>Access and Affordability</th>
              <td className={ styles.stat_value }>{ data['ACCESS']['Current'] }</td>
              <td className={ rankingStyles['ACCESS'] }>{ formattedDiffs['ACCESS'] }</td>
            </tr>
            <tr>
              <th>Prevention and Treatment</th>
              <td className={ styles.stat_value }>{ data['QUALITY']['Current'] }</td>
              <td className={ rankingStyles['QUALITY'] }>{ formattedDiffs['QUALITY'] }</td>
            </tr>
            <tr>
              <th>Avoidable Hospital Use and Cost</th>
              <td className={ styles.stat_value }>{ data['USE']['Current'] }</td>
              <td className={ rankingStyles['USE'] }>{ formattedDiffs['USE'] }</td>
            </tr>
            <tr>
              <th>Healthy Lives</th>
              <td className={ styles.stat_value }>{ data['LIVES']['Current'] }</td>
              <td className={ rankingStyles['LIVES'] }>{ formattedDiffs['LIVES'] }</td>
            </tr>
            <tr>
              <th>Disparity</th>
              <td className={ styles.stat_value }>{ data['DISPARITY']['Current'] }</td>
              <td className={ rankingStyles['DISPARITY'] }>{ formattedDiffs['DISPARITY'] }</td>
            </tr>
            <tr>
              <th>Medicaid Expansion</th>
              <td className={ styles.stat_value }>{ data['medicaid']['Current'] }</td>
              <td className={ rankingStyles['medicaid'] }>{ formattedDiffs['medicaid'] }</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h2 className="section__title__secondary">Demographics</h2>
      <div className={ styles.ranking__table__wrapper }>
        <table className={ styles.ranking__table }>
          <thead>
            <tr>
              <th></th>
              <th className={ styles.stat_value }>{ title }</th>
              <th className={ styles.stat_change }>Average</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Total Population</th>
              <td className={ styles.stat_value }>{demographics[state].population.toLocaleString()}</td>
              <td className={ styles.stat_change }>{demographics['US'].population.toLocaleString()}</td>
            </tr>
            <tr>
              <th>Median Household Income</th>
              <td className={ styles.stat_value }>${demographics[state].income.toLocaleString()}</td>
              <td className={ styles.stat_change }>${demographics['US'].income.toLocaleString()}</td>
            </tr>
            <tr>
              <th>Below 200% of Federal Poverty Level (FPL)</th>
              <td className={ styles.stat_value }>{demographics[state].poverty}%</td>
              <td className={ styles.stat_change }>{demographics['US'].poverty}%</td>
            </tr>
            <tr>
              <th>% White Race, Non-Hispanic</th>
              <td className={ styles.stat_value }>{demographics[state].white}%</td>
              <td className={ styles.stat_change }>{demographics['US'].white}%</td>
            </tr>
            <tr>
              <th>% Black Race, Non-Hispanic</th>
              <td className={ styles.stat_value }>{demographics[state].black}%</td>
              <td className={ styles.stat_change }>{demographics['US'].black}%</td>
            </tr>
            <tr>
              <th>% Other Race, Non-Hispanic</th>
              <td className={ styles.stat_value }>{demographics[state].other}%</td>
              <td className={ styles.stat_change }>{demographics['US'].other}%</td>
            </tr>
            <tr>
              <th>% Hispanic Ethnicithy</th>
              <td className={ styles.stat_value }>{demographics[state].hispanic}%</td>
              <td className={ styles.stat_change }>{demographics['US'].hispanic}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default StateRankingTable



// WEBPACK FOOTER //
// ./src/components/StateRankingTable/StateRankingTable.js